import React from 'react';
import { useSelector } from 'react-redux';

const PartialProtectedRoute = ({ children }) => {
  const { loading } = useSelector((state) => state.auth);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Always render children - components can access isAuthenticated from Redux directly
  return <>{children}</>;
};

export default PartialProtectedRoute;
